import axios from 'axios'
import { UAParser } from 'ua-parser-js';
import { useDispatch } from 'react-redux'

import {
  verifyLogged,
} from 'app/services/auth';
import {APP_NAME, APP_VERSION} from 'app/config/appMeta'

const Interceptor = (store) => {
  const { browser, device, os } = UAParser();
  const dispatch = useDispatch();

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { authToken }
      } = store.getState();

      if (!config.url.includes('api.pagar.me') && !config.url.includes('viacep')) {
        if (authToken) {
          config.headers.Authorization = `Bearer ${authToken}`;
        }

        config.headers['Browser-Name'] = browser.name;
        config.headers['Browser-Version'] = browser.version;
        config.headers['Browser-Major'] = browser.major;
        config.headers['System-Name'] = os.name;
        config.headers['System-Version'] = os.version;
        config.headers['Model'] = device.model;
        config.headers['Device-Type'] = device.type;
        config.headers['Application-Name'] = APP_NAME;
        config.headers['App-Version'] = APP_VERSION;
      }

      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    (err) => {
      if (err.response && err.response.status === 401) {
        return dispatch<any>(verifyLogged(false, null, false)).then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              err.config.baseURL = undefined;
              axios.request(err.config)
                .then(resolve)
                .catch(reject);
            }, 1000);
          });
        });
      } else {
        return Promise.reject(err);
      }
    }
  );
}

export default Interceptor;
